export default __webpack_public_path__ + "static/media/HTML5.273bc048.png";